import { render } from "./MMStockPage.vue?vue&type=template&id=f9ca9b72"
import script from "./MMStockPage.vue?vue&type=script&lang=js"
export * from "./MMStockPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__